import React from 'react';
import WaterDropOutlinedIcon from '@mui/icons-material/WaterDropOutlined';
import { ZONAS_INUNDABLES_LEGEND } from '../LayerSelectorPanel/MapLayerOptions';
import { REFERENCE_LAYERS_MIN_ZOOM } from '../../styles/mapTheme';
import ReferenceLayerRow from './ReferenceLayerRow';

// ─── Detalle ──────────────────────────────────────────────────────────────────

const ZonasInundablesDetail = () => (
  <div style={{
    marginTop: '10px',
    paddingTop: '10px',
    borderTop: '1px solid rgba(255,255,255,0.07)',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  }}>
    <div style={{
      fontSize: '10px',
      fontWeight: '600',
      color: 'rgba(255,255,255,0.4)',
      textTransform: 'uppercase',
      letterSpacing: '0.5px',
    }}>
      Nivel de riesgo
    </div>

    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: '6px 10px',
      }}
    >
      {ZONAS_INUNDABLES_LEGEND.map((item) => (
        <div
          key={item.value}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '5px',
            flexShrink: 0,
          }}
        >
          <span style={{
            width: '10px',
            height: '10px',
            borderRadius: '2px',
            backgroundColor: item.color,
            opacity: 0.9,
            flexShrink: 0,
            border: '1px solid rgba(0,0,0,0.25)',
          }} />
          <span style={{ fontSize: '11px', color: 'rgba(255,255,255,0.7)', whiteSpace: 'nowrap' }}>
            {item.label}
          </span>
        </div>
      ))}
    </div>
  </div>
);

// ─── Fila completa ────────────────────────────────────────────────────────────

/**
 * Fila de la capa "Zonas inundables" lista para usar en ReferenceLayersPanel.
 *
 * Props:
 *  - enabled    Si la capa está activa.
 *  - onToggle   Callback al hacer click en el toggle.
 */
const ZonasInundablesLayer = ({ enabled, onToggle, disabled = false, mapZoom = null }) => (
  <ReferenceLayerRow
    icon={WaterDropOutlinedIcon}
    title="Zonas inundables"
    sublabel="Riesgo de inundación"
    enabled={enabled}
    onToggle={onToggle}
    disabled={disabled}
    mapZoom={mapZoom}
    minZoomToView={REFERENCE_LAYERS_MIN_ZOOM.zonasInundables}
    zoomHintSublabel="Acercá más el zoom"
  >
    <ZonasInundablesDetail />
  </ReferenceLayerRow>
);

export default ZonasInundablesLayer;
